<template src="./index.html"></template>
<script>
import {getdata} from "./data.js";
import config from "../../../../../../configHttp.js";
import { iinvSubLegerVoucherDetailQuery, queryCompanyList, iinvSubLegerVoucherDetailDelete, getCompanyObstWithVoucher } from "../../../../../api/subLeger.js";
export default {
  name: "",
  components: {},
  data: function () {
    return {
      searchdata: getdata().searchdata,
      searchlist: getdata().searchlist,
      outlist: [],
      headData: getdata().headData,
      pagination: getdata().pagination,
      tableData: [],
      shaidiag: false,
      searchdiag: false,
      tablekey: 0,
      overlength: 0,
      deleteList: [],
      businessTypeList: []
    };
  },
  mounted() {},
  created() {
    this.voucherDetailPage();
    this.loadData();
  },
  methods: {	  
    geOoverLength(e){
		  this.overlength = e;
	  },
    sizechange(e) {
      this.pagination.pageSize = e;
      this.voucherDetailPage();
    },
    currentChange(e) {
      this.pagination.pageNum = e;
      this.voucherDetailPage();
    },
    submitSearch() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.voucherDetailPage();
    },
    forRefresh() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.voucherDetailPage();
      this.loadData();
    },
    voucherDetailPage() {
      let params = JSON.parse(JSON.stringify(this.searchdata));
      params.current = this.pagination.pageNum;
      params.size = this.pagination.pageSize;
      params.sort = "";
      params.order = "";
      iinvSubLegerVoucherDetailQuery(params).then((res) => {
        this.pagination.total = res.data.data.total;
        this.tableData = res.data.data.records;
      });
    },
    loadData() {
      getCompanyObstWithVoucher({bsType: "2"}).then(res => {
        this.searchlist.forEach(item => {
          if (item.prop == 'businessType') {
              item.selectval = res.data.data;
              this.businessTypeList = res.data.data;
          }
        });
        let newarr = JSON.parse(JSON.stringify(this.searchlist));
			  this.searchlist = newarr;
      });

      queryCompanyList().then(res => {
        if (res.data.code === 1) {
          let companyCodeVal = [];
          for (let i = 0; i < res.data.data.length; i++) {
            companyCodeVal.push({label: res.data.data[i].companyCode, value: res.data.data[i].companyCode})
          }
          this.searchlist[0].selectval = companyCodeVal;
          this.searchlist = JSON.parse(JSON.stringify(this.searchlist));
        } else {
          this.$message.error(res.data.msg)
        }
      });
    },
    forUpdateSearch() {
      this.searchdiag = true;
    },
    closeSearch() {
      this.searchdiag = false;
    },
    saveChange(e) {
      this.searchdiag = false;
    },
    confirmfilter(e) {
      this.headData = e.chooselist;
      this.outlist = e.nochooselist;
      this.shaidiag = false;
    },
    closeshaidiag() {
      this.shaidiag = false;
    },
    //导出列表：
    exportExcel() {
      //得到勾选的列表值：
      var chooseitem = this.$refs.tablebox.getSelectionval();
	
      let data = {id:[],subLegerSearchInputDTO:{}};
      if (chooseitem.length > 0) {
        data.ids = chooseitem.map((item) => item.id);
      } else {
        data.subLegerSearchInputDTO = JSON.parse(JSON.stringify(this.searchdata));
      }
      let params = {
        downUrl: config.baseURL + "/subLeger/iinv/details/export",
        typeObj: {
          toForm: false,
          fileType: "xlsx",
          failUrl:this.$winURl
        },
        params: data,
      };
      this.$downloadcommon(params);
    },
    deleteVoucherDetail() {
      var chooseitem = this.$refs.tablebox.getSelectionval();
      if (chooseitem.length == 0) {
				return this.$message.error('请选择你要删除的数据');
			}
      this.$showConfirm({
				message: '确认删除?'
			}).then(res => {
				if (res == 'confirm') {
          let delFlag = true;
					let ids = [];
					chooseitem.map(item => {
            if (item.businessMatchStatus != '0' && item.businessMatchStatus != '2') {
              delFlag = false;
              return this.$message.error('只能删除未匹配/暂不处理的数据,凭证号：' + item.voucherNo);
            }
						ids.push(item.id);
					});
          if(!delFlag) {
            return;
          }
          let params = {ids: ids.join(",")};
          iinvSubLegerVoucherDetailDelete(params).then(res => {
						if (res.data.code == 1) {
							this.$message.success('删除成功');
							this.voucherDetailPage();
						} else {
							this.$message.error(res.data.code);
						}
					});
				}
			});

    }
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
